module.exports = __webpack_public_path__ + "img/fire80.b00d8f77.gif";